/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_PtInputs */

const en_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const es_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const de_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const zh_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const ar_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const fr_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const vi_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const sw_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const th_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const bs_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const ja_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const ko_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const pt_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const it_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const sv_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const nl_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const da_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const nb_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const fi_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const pl_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const ru_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const tr_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const hi_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const id_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const ms_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const cs_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const el_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const he_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const af_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

const hu_nav_language_pt = /** @type {(inputs: Nav_Language_PtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Português`)
};

/**
* | output |
* | --- |
* | "Português" |
*
* @param {Nav_Language_PtInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_pt = /** @type {((inputs?: Nav_Language_PtInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_PtInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_pt(inputs)
	if (locale === "de") return de_nav_language_pt(inputs)
	if (locale === "zh") return zh_nav_language_pt(inputs)
	if (locale === "ar") return ar_nav_language_pt(inputs)
	if (locale === "fr") return fr_nav_language_pt(inputs)
	if (locale === "vi") return vi_nav_language_pt(inputs)
	if (locale === "sw") return sw_nav_language_pt(inputs)
	if (locale === "th") return th_nav_language_pt(inputs)
	if (locale === "bs") return bs_nav_language_pt(inputs)
	if (locale === "ja") return ja_nav_language_pt(inputs)
	if (locale === "ko") return ko_nav_language_pt(inputs)
	if (locale === "pt") return pt_nav_language_pt(inputs)
	if (locale === "it") return it_nav_language_pt(inputs)
	if (locale === "sv") return sv_nav_language_pt(inputs)
	if (locale === "nl") return nl_nav_language_pt(inputs)
	if (locale === "da") return da_nav_language_pt(inputs)
	if (locale === "nb") return nb_nav_language_pt(inputs)
	if (locale === "fi") return fi_nav_language_pt(inputs)
	if (locale === "pl") return pl_nav_language_pt(inputs)
	if (locale === "ru") return ru_nav_language_pt(inputs)
	if (locale === "tr") return tr_nav_language_pt(inputs)
	if (locale === "hi") return hi_nav_language_pt(inputs)
	if (locale === "id") return id_nav_language_pt(inputs)
	if (locale === "ms") return ms_nav_language_pt(inputs)
	if (locale === "cs") return cs_nav_language_pt(inputs)
	if (locale === "el") return el_nav_language_pt(inputs)
	if (locale === "he") return he_nav_language_pt(inputs)
	if (locale === "af") return af_nav_language_pt(inputs)
	if (locale === "hu") return hu_nav_language_pt(inputs)
	return en_nav_language_pt(inputs)
});